export default __webpack_public_path__ + "static/media/sman_29_jakarta-removebg-preview 1.c610d2b9.png";